import { DRAWABLE_TYPES } from '../../../shared/constants/drawable-types'
import { ActiveGeometryGroup } from '../../slices/geometry'
import { BEAM_TYPES } from '../../utils/constants'

export function isActiveDrawableHeader(activeDrawableGroup: ActiveGeometryGroup | null): boolean {
    if (!activeDrawableGroup || activeDrawableGroup === undefined) {
        return false
    }

    return (
        activeDrawableGroup.type === DRAWABLE_TYPES.BEAM &&
        activeDrawableGroup.settings?.beam_type === BEAM_TYPES.HEADER
    )
}
